<!-- ADD/EDIT NOTA DE VENTA -->
<div [hidden]="!mostrar">
  <app-nota-venta-cabecera (onHeaderDataChange)="handleHeaderDataChange($event)"
    (onApplyGlobalDiscount)="onApplyGlobalDiscount($event)"
    [permiteUnidadNegocio]="permiteUnidadNegocio" [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio">
  </app-nota-venta-cabecera>

  <app-nota-venta-detalles (onAddProductoRequest)="onAddProductoRequest($event)"
    (onDeleteProductoRequest)="onDeleteProductoRequest($event)" 
    (onEditingProduct)="changeOnEditingProduct($event)"
    [permiteUnidadNegocio]="permiteUnidadNegocio"
    [cabeceraComponent]="cabeceraComponent">
  </app-nota-venta-detalles>

  <div class="card mb-2 wow">
    <div class="card-body d-sm-flex p-1 ">

      <div>
        <button size="sm" class="btn btn-sm ColorBtnClose" mdbBtn type="button" color="info" mdbWavesEffect
          (click)="CloseNotaVenta()">
          Cerrar
        </button>
      </div>
      <div class="card-body d-sm-flex p-1  justify-content-end">
        <button *ngIf="mode == 'ADD'" size="sm" class="btn btn-sm" mdbBtn type="button" color="info" mdbWavesEffect
          (click)="clearFromButton()">
          Limpiar
        </button>

        <app-api-button *ngIf="mode != 'SHOW'" (click2)="guardarNotaVenta()" [processing]="processing" [disabled]="onEditingProduct">
          Guardar
        </app-api-button>
      </div>



    </div>
  </div>



  <app-modal-confirm title="Limpiar datos" contentText="¿Desea limpiar los datos ingresados?">
  </app-modal-confirm>

</div>